// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  errors: false,
  block: false
}

const logs = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_LOGS':
      return { ...state, allData: action.data }
    case 'GET_DATA_LOGS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        block: false
      }
    case 'BLOCK':
      return { ...state, block: true }
    case 'UNBLOCK':
      return { ...state, block: false }
    default:
      return { ...state }
  }
}
export default logs
